import styled from "styled-components";

export const StyledWrapper = styled.div`
  > h1 {
    margin-top: 16px;
    color: ${({ theme }) => theme.colors.neutralsText};
    ${({ theme }) => theme.fontStyles.DesktopHeadlinesH5}
  }
`;

export const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colors.primaryRulerTint50};
`;
